
document.addEventListener( 'DOMContentLoaded', initAuthloginout );

function initAuthloginout() {
	const txtElements = document.querySelectorAll( '.wp-block-aver-loginout-block' );

	txtElements.forEach( ( txtElement ) => {
		new Authloginout( txtElement );
	} );
}

class Authloginout {
	constructor( txtElement ) {
		this.txtElement = txtElement;
		this.loginoutEl = txtElement;
		if ( this.loginoutEl ) {
		
			this.container = this.loginoutEl
			this.showPasswords = this.loginoutEl.querySelectorAll('.showPassword')
			this.tabs = this.loginoutEl.querySelectorAll( '.tabs li>div' );
			this.tabscontent = this.loginoutEl.querySelectorAll( '.loginout-body form' );
			this.loginoutbody = this.loginoutEl.querySelector( '.loginout-body' );
			this.signupForm = this.loginoutEl.querySelector( '#signup-tab' );
			this.signinForm = this.container.querySelector( '#signin-tab' );
			this.forgetForm = this.container.querySelector( '#forget-tab' );		
			this.logoutbtn = this.loginoutEl.querySelector('#logout-btn');
			this.signupStatus = this.loginoutEl.querySelector( '#signup-status' );
			if ( this.signupForm ) 	this.signupFieldset = this.signupForm.querySelector( 'fieldset' );
			if ( this.signinForm ) 	this.signinFieldset = this.signinForm.querySelector( 'fieldset' );
			if ( this.forgetForm ) 	this.forgetFieldset = this.forgetForm.querySelector( 'fieldset' );
			this.signinStatus = this.loginoutEl.querySelector( '#signin-status' );
			this.signoutStatus = this.container.querySelector('#signout-status')
			this.forgetStatus = this.container.querySelector('#forget-status')
			
			this.events();
		}
	}

	events() {
		// this.showPasswords.forEach(item=>{
		// 	item.addEventListener('change', e=>{
		// 		if( e.target.checked ) {
		// 			e.target.previousElementSibling.type = 'text'    					
		// 		} else {
		// 			e.target.previousElementSibling.type = 'password'  
		// 		}
		// 	})
		// })

		this.showPasswords.forEach(item=>{
			item.addEventListener('click', e=>{

				let siblinginput = e.target.previousElementSibling 
				//console.log(siblinginput)
				//console.log(e.target)

				if (siblinginput.type === 'password') {
					siblinginput.type = 'text';
					e.target.classList.add('bi-eye'); // Eye with slash icon (to indicate hiding)
					e.target.classList.remove('bi-eye-slash'); // Eye with slash icon (to indicate hiding)
				} else {
						siblinginput.type = 'password';
						e.target.classList.remove('bi-eye'); // Eye with slash icon (to indicate hiding)
						e.target.classList.add('bi-eye-slash'); // Eye with slash icon (to indicate hiding)
				}

				
			})
		})

		
		this.tabs.forEach( ( item ) => {
			item.addEventListener( 'click', ( e ) => {
				
				this.tabs.forEach( ( item ) => {
					item.classList.remove( 'active-tab' );
				} );
				this.tabscontent.forEach( ( item ) => {
					item.style.display = 'none';
				} );
				e.target.classList.add( 'active-tab' );
				let name = e.target.getAttribute( 'data-id' );
				//console.log(name)
				this.loginoutbody.querySelector( name ).style.display = 'block';
			} );
		} );

		if (this.logoutbtn){
			
			this.logoutbtn.addEventListener('click', async (e)=>{
				e.preventDefault();

				this.signoutStatus.innerHTML = `
				<div class="p-text-yellow">
					Plese wait... We are logging you out.
				</div>      
				`;
       
				const response = await fetch( up_auth_rest.signout, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify(),
				} );

				const responseJSON = await response.json();
				if ( responseJSON.status === 2 ) {	
					this.signoutStatus.innerHTML = `
						<div class="p-text-green">
							Success! You have successfully sign out.
						</div>
					`;				
					location.reload();
				} else {
					this.signoutStatus.innerHTML = `
						<div class="p-text-red">
							Error signing out... 
						</div>
					`;				
				}

			})
		}

		if ( this.forgetForm ) {
			this.forgetForm.addEventListener( 'submit', async ( e ) => {
				e.preventDefault();
				this.forgetFieldset.setAttribute( 'disabled', true );
				this.forgetStatus.innerHTML = `
				<div class="p-text-yellow">
					Plese wait... We are checking your account.
				</div>      
				`;
				const formData = {
					useremail: this.forgetForm.querySelector( '#email-name' ).value,
				}
				const response = await fetch( up_auth_rest.forgetpassword, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify( formData ),
				} );

				const responseJSON = await response.json();
				//console.log( responseJSON.status )
				if ( responseJSON.status === 2 ) {
					this.forgetStatus.innerHTML = `
						<div class="p-text-green">
							Success! Your account has been created.
						</div>
					`;
					location.reload();
				} else {
					this.forgetFieldset.removeAttribute( 'disabled' );

					if ( responseJSON.status === 3 ) {
						this.forgetStatus.innerHTML = `
						<div class="p-text-red">
							The email is not registered.
						</div>
						`;
					} 
				}
				
			})
		}

		if ( this.signupForm ) {
			this.signupForm.addEventListener( 'submit', async ( e ) => {
				e.preventDefault();
				this.signupFieldset.setAttribute( 'disabled', true );
				this.signupStatus.innerHTML = `
				<div class="p-text-yellow">
					Plese wait... We are creating your account.
				</div>      
				`;
				const formData = {
					username: this.signupForm.querySelector( '#su-name' ).value,
					email: this.signupForm.querySelector( '#su-email' ).value,
					password: this.signupForm.querySelector( '#su-password' ).value,
				};
				// #179 // make a custom endpoint and localized the path
				const response = await fetch( up_auth_rest.signup, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify( formData ),
				} );

				const responseJSON = await response.json();
				//console.log( responseJSON.status )

				if ( responseJSON.status === 2 ) {
					this.signupStatus.innerHTML = `
						<div class="p-text-green">
							Success! Your account has been created.
						</div>
					`;
					location.reload();
				} else {
					this.signupFieldset.removeAttribute( 'disabled' );

					if ( responseJSON.status === 3 ) {
						this.signupStatus.innerHTML = `
						<div class="p-text-red">
							Please fill in all the informations and try again.
						</div>
						`;
					} else if ( responseJSON.status === 4 ){
						this.signupStatus.innerHTML = `
						<div class="p-text-red">
							Duplicate user name or email.
						</div>
						`;
					} else if ( responseJSON.status === 5 ){
						this.signupStatus.innerHTML = `
						<div class="p-text-red">
							We can not create user right now, please try again later.
						</div>
						`;
					}
					
				}
			} );
		}

		if ( this.signinForm ) {
			this.signinForm.addEventListener( 'submit', async ( event ) => {
				event.preventDefault();

				this.signinFieldset.setAttribute( 'disabled', true );
				this.signinStatus.innerHTML = `
					<div class="p-text-yellow">
						Please wait! We are logging you in.
					</div>
				`;

				const formData = {
					user_login: this.signinForm.querySelector( '#si-email' ).value,
					password: this.signinForm.querySelector( '#si-password' ).value,
				};

				const response = await fetch( up_auth_rest.signin, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify( formData ),
				} );

				const responseJSON = await response.json();

				if ( responseJSON.status === 2 ) {
					this.signinStatus.innerHTML = `
						<div class="p-text-green">
							Success! You are now logged in.
						</div>
					`;
					location.reload();
				} else {
					this.signinFieldset.removeAttribute( 'disabled' );
					this.signinStatus.innerHTML = `
						<div class="p-text-red">
							Invalid credentials! Please try again later.
						</div>
					`;
				}
			} );
		}

	}
}
